'use client';

import type { ReactNode } from 'react';
import { CustomImage } from 'components';
import styles from './PaymentOptions.module.css';

export type PaymentOptionsData = {
  icons: string[];
  text: ReactNode;
};

export type PaymentOptionsProps = {
  data: PaymentOptionsData;
  onSeeAll?: () => void;
};

export const PaymentOptions = ({ data, onSeeAll }: PaymentOptionsProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.icons} aria-hidden="true">
          {data.icons.map((icon, index) => (
            <CustomImage
              key={`${icon}-${index}`}
              src={icon}
              alt=""
              width="24"
              height="24"
            />
          ))}
        </div>
        <span className={styles.caption}>{data.text}</span>
      </div>
      {onSeeAll ? (
        <button type="button" className={styles.seeAllButton} onClick={onSeeAll}>
          See all
        </button>
      ) : null}
    </div>
  );
};
